"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexes = void 0;
const indexes = (table) => {
    const result = ['label'];
    return result;
};
exports.indexes = indexes;
//# sourceMappingURL=indexes.js.map